import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { MatSliderModule } from '@angular/material/slider';

import { SCWShardsItemComponent } from './item.component';

@NgModule({
  imports: [
    CommonModule,
    ReactiveFormsModule,
    RouterModule,
    MatSliderModule,
  ],
  exports: [ SCWShardsItemComponent ],
  declarations: [ SCWShardsItemComponent ],
  providers: [],
})
export class SCWShardsItemModule {

}
